
import cartMixins from "~/plugins/cartMixins";
export default {
  mixins: [cartMixins],
  data() {
    return {
      mobileChinHide: false,
      newAddress: false,
      userOpen: false,
      shippingOpen: false,
      pickupOpen: false,
      userTitle: false,
      bottomHeight: 80,
    };
  },
  mounted() {},
  methods: {
    toggleSamples(s) {
      if (!this.cart.samples) {
        this.cart.samples = [];
      }
      let found = this.cart.samples.findIndex((ss) => ss._id == s._id);
      if (found > -1) {
        this.cart.samples = this.cart.samples.filter(
          (ss, index) => index != found
        );
      } else {
        this.cart.samples.push(s);
      }
      this.$hyperCart.saveCart(this.cart);
    },
    async releaseGiftcard(code) {
      let t = await this.$clerk.hyperAlert({
        html: `<p>Αφαίρεση εκπτωτικού κωδικού <span class="font-bold">${code}</span>;</p>`,
        cancelShow: true,
        confirmButtonText: "Αφαίρεση",
      });
      if (t.isConfirmed) {
        try {
          let c = await this.$axios.$post(
            `/utilities/cosmote-deals-for-you/${this.$store.getters.store.store_id}`,
            {
              action: "release",
              tid: this.$store.getters.cart.id,
              coupon: code,
            }
          );
          this.cart.giftcards = this.cart.giftcards.filter((_) => _.code != code);
          this.$hyperCart.saveCart(this.cart);
        } catch (e) {
          console.error(e);
        }
      }
    },
  },
  computed: {
    calculateFavorites() {
      let t = (this.$store.getters.user || {}).actualFavorites;
      if (t) {
        return t.reduce((acc, _) => {
          if (_.selectedFavorite) {
            acc += this.$hyperItem.actualPrice(_, false, _.quantity);
          }
          return acc;
        }, 0);
      } else {
        return 0;
      }
    },
  },
};
